import axios from "axios";
import { Order } from "types/order";

interface OrderStatusItemPayload {
  od_os: string;
  product_name: string;
  tracking_url?: string;
  status_code: string;
  display_status?: string;
}

export interface GetOrderStatusResponse {
  order_num: number | string;
  order_date: string;
  expect_date: string;
  order_type_name: "eyeglasses" | "soft_contacts" | "E" | "S" | "Dry Eye";
  display_status?: string;
  display_byline?: string;
  fulfillment_type?: string;
  fulfillment_destination?: string;
  fulfillment_destination_map_url?: string;
  online_order?: boolean;
  is_expandable?: boolean;
  shared_tracking_url?: string;
  items?: OrderStatusItemPayload[];
}

export const getOrderStatusRequest = async (
  orderUID: string
): Promise<Order[]> => {
  try {
    const { data } = await axios.get<{ order_tracking_info: GetOrderStatusResponse[] }>(
      `/api/order_status/${orderUID}`
    );
    return data.order_tracking_info.map((pref) => ({
      orderNum: pref.order_num,
      orderDate: pref.order_date,
      orderTypeName: pref.order_type_name,
      onlineOrder: pref.online_order ?? false,
      expectDate: pref.expect_date,
      fulfillmentType: pref.fulfillment_type,
      fulfillmentDestination: pref.fulfillment_destination,
      fulfillmentDestinationMapUrl: pref.fulfillment_destination_map_url,
      displayByline: pref.display_byline,
      displayStatus: pref.display_status,
      isExpandable: pref.is_expandable,
      sharedTrackingUrl: pref.shared_tracking_url,
      items: pref.items?.map((item) => ({
        odOs: item.od_os,
        productName: item.product_name,
        trackingUrl: item.tracking_url,
        statusCode: item.status_code,
        displayStatus: item.display_status,
      })),
    }));
  } catch (err) {
    return [];
  }
};
